
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';


export function useInputMask(format, onAccept) {
    const inputElement = ref(null);
    const maskInstance = ref(null);
    const hasMask = computed(() => !!maskInstance.value);

    const updateMaskFormat = (newFormat) => {
        if (maskInstance.value && newFormat) {
            maskInstance.value.updateOptions({
                ...newFormat,
                lazy: !newFormat.placeholder
            });
        }
    };

    const resolveMaskBlocks = (blocks, imask) => {
        if (!blocks) return blocks;
        return Object.fromEntries(
            Object.entries(blocks).map(([key, block]) => [
                key,
                { ...block, mask: block.mask === 'MaskedRange' ? imask.MaskedRange : block.mask }
            ])
        );
    };

    const attachInputMask = async () => {
        if (format) {
            const imask = await import('imask');
            const maskOptions = {
                ...format,
                blocks: resolveMaskBlocks(format.blocks, imask),
                lazy: !format.placeholder
            };

            maskInstance.value = imask.default(inputElement.value, maskOptions);
            if (onAccept) {
                maskInstance.value.on('accept', () => onAccept(maskInstance.value));
            }
        }
    };

    const detachInputMask = () => {
        if (maskInstance.value) {
            maskInstance.value.destroy();
            maskInstance.value = null;
        }
    };

    const updateMaskedValue = (event) => {
        if (maskInstance.value) {
            maskInstance.value.updateValue();
            return maskInstance.value.value;
        }
        return event ? event.target.value : '';
    };

    const getMaskedValue = () => {
        if (maskInstance.value) {
            return maskInstance.value.value;
        }

        return inputElement.value ? inputElement.value.value : '';
    };

    onMounted(attachInputMask);
    onBeforeUnmount(detachInputMask);

    return {
        inputElement,
        maskInstance,
        hasMask,
        updateMaskedValue,
        getMaskedValue,
        updateMaskFormat,
        attachInputMask,
        detachInputMask
    };
}